var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.course)?_c('div',{staticClass:"animated fadeInRight"},[_c('div',{staticClass:"wrapper wrapper-content row"},[_c('div',{staticClass:"col-lg-12"},[_c('LikeButtons',{attrs:{"course-data":_vm.course,"show-btn":true}}),_c('router-view',{key:_vm.$route.path})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }